<template>
  <div class="seek_detail_page" v-loading="isLoading">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        查看详情
      </div>
      <div class="flex">
        <el-button
          size="mini"
          type="primary"
          @click="handleHistory"
          style="margin-right: 10px"
          >历史索赔记录</el-button
        >
        <zip-btn
          :name="claimant.claimStatementId"
          v-show="fileList && fileList.length > 0"
          :fileList="fileList"
        />
      </div>
    </div>
    <div class="status-container">
      <div>索赔单号：{{ claimant.claimStatementId }}</div>
      <div class="status">状态：{{ claimant.auditResultDisplay }}</div>
      <span
        v-if="pageIndex === 'detail'"
        class="btn"
        @click="handleViewRecord('record')"
        >查看记录</span
      >
    </div>

    <div v-if="formLoading && pageIndex === 'detail'" class="form_info">
      <el-form :inline="true" :model="claimant" label-width="160px">
        <!-- 索赔基本信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            索赔基本信息
          </div>
        </div>
        <div class="form-container">
          <!-- 索赔节点 -->
          <el-form-item label="索赔节点">
            <el-select v-model="claimant.claimNode" disabled filterable clearable>
              <el-option label="开箱" value="1"> </el-option>
              <el-option label="制程" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="索赔类型">
            <el-select v-model="claimant.claimType" disabled filterable clearable>
              <el-option
                v-for="(item, index) in splxList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开箱日期">
            <el-input disabled v-model="claimant.openBoxDate"></el-input>
          </el-form-item>
          <el-form-item label="销售订单号">
            <el-input disabled v-model="claimant.claimStatementNum"></el-input>
          </el-form-item>
          <el-form-item label="零部件专业" prop="lbjzyList">
            <el-select v-model="claimant.lbjzyList" disabled multiple filterable clearable>
              <el-option
                v-for="(item, index) in partMajorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- VIN -->
          <el-form-item label="VIN" v-show="claimant.claimNode == 2">
            <el-input disabled v-model="claimant.vin"></el-input>
          </el-form-item>
          <!-- 国家 -->
          <el-form-item label="国家" prop="customerCountry">
            <el-select
              disabled
              filterable
              clearable
              v-model="claimant.countryId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in Object.values(getSession('nationList'))"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户账号">
            <el-input v-model="claimant.customerAccount" disabled></el-input>
          </el-form-item>
            <el-form-item label="客户索赔号">
              <el-input v-model="claimant.customerClaimNumber" disabled></el-input>
            </el-form-item>
        </div>
        <!-- 配件故障信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            配件故障信息
          </div>
        </div>
        <div class="form-container">
          <!-- 发生日期 -->
          <el-form-item label="发生日期">
            <el-date-picker
              disabled
              type="date"
              value-format="yyyy-MM-dd"
              v-model="claimant.happenDate"
            ></el-date-picker>
          </el-form-item>
          <!-- 问题类别 -->
          <el-form-item label="问题类别" prop="problemCategory">
            <el-select v-model="claimant.problemCategory" disabled filterable clearable>
              <el-option label="客户PDI" value="客户PDI"> </el-option>
              <el-option label="终端客户" value="终端客户"> </el-option>
              <el-option label="零部件质量" value="零部件质量"> </el-option>
              <el-option label="零部件差缺" value="零部件差缺"> </el-option>
              <el-option label="零部件运损" value="零部件运损"> </el-option>
              <el-option label="零部件功能性" value="零部件功能性"> </el-option>
              <el-option label="零部件制程" value="零部件制程"> </el-option>
              <el-option label="港口救援" value="港口救援"> </el-option>
              <el-option label="零部件包装" value="零部件包装"> </el-option>
            </el-select>
          </el-form-item>

          <!-- 故障现象 -->
          <div class="fanyi-box">
            <el-form-item label="故障现象原文" label-width="140px">
              <el-input
                type="textarea"
                v-model="claimant.symptom"
                style="width: 670px"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="claimant.symptom"
                field="symptomCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item label="故障现象" prop="symptomCn" label-width="140px">
              <el-input
                type="textarea"
                v-model="claimant.symptomCn"
                style="width: 670px"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障初步原因 -->
          <div class="fanyi-box">
            <el-form-item label="故障初步原因原文" label-width="140px">
              <el-input
                type="textarea"
                v-model="claimant.preliminaryCauseOfFailure"
                style="width: 670px"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="claimant.preliminaryCauseOfFailure"
                field="preliminaryCauseOfFailureCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item
              label="故障初步原因"
              prop="preliminaryCauseOfFailureCn"
              label-width="140px"
            >
              <el-input
                type="textarea"
                v-model="claimant.preliminaryCauseOfFailureCn"
                style="width: 670px"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障处理方案 -->
          <div class="fanyi-box">
            <el-form-item label="故障处理方案原文" label-width="140px">
              <el-input
                type="textarea"
                v-model="claimant.processingScenarios"
                style="width: 670px"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <translate
                style="margin-top: 30px; padding-left: 10px"
                :content="claimant.processingScenarios"
                field="processingScenariosCn"
                @getTranslateVal="getTranslateVal"
              />
            </el-form-item>
            <br />
            <el-form-item
              label="故障处理方案"
              prop="processingScenarios"
              label-width="140px"
            >
              <el-input
                type="textarea"
                v-model="claimant.processingScenariosCn"
                style="width: 670px"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <!-- 故障件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            故障件信息
          </div>
        </div>
        <div class="table-container" style="padding: 15px 18px 0 54px">
          <el-table :data="claimant.kdClaimFaultyPartsEntityList" border stripe>
            <!-- 序号 -->
            <el-table-column
              type="index"
              label="序号"
              width="60"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="boxNumber"
              label="外包装箱号"
              width="120"
              align="center"
            >
            </el-table-column>

            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              label="故障件件号"
              align="center"
              min-width="220px"
            >
            </el-table-column>
            <el-table-column
              prop="faultPartNameZh"
              label="故障件名称"
              align="center"
              min-width="240px"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.faultPartNameZh">{{
                  scope.row.faultPartNameZh
                }}</span>
                <span v-else>{{ scope.row.faultPartName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="faultPartUnitPrice"
              label="故障件单价"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.faultPartUnitPrice }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="cartonNumber"
              label="纸箱号"
              align="center"
              min-width="120px"
            >
            </el-table-column>
            <el-table-column
              prop="changeQuantity"
              label="更换数量"
              align="center"
              min-width="90px"
            >
            </el-table-column>
            <el-table-column
              prop="repairPlan"
              label="维修方案"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                <!-- <el-select size="mini" v-model="scope.row.repairPlan" disabled>
                  <el-option label="维修" :value="0"> </el-option>
                  <el-option label="更换" :value="1"> </el-option>
                  <el-option label="补发" :value="2"> </el-option>
                </el-select> -->
                {{ scope.row.repairPlan === 0 ? "维修" : "" }}
                {{ scope.row.repairPlan === 1 ? "更换" : "" }}
                {{ scope.row.repairPlan === 2 ? "补发" : "" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="sourceOfComponents"
              label="零部件来源"
              align="center"
              min-width="160px"
            >
              <template slot-scope="scope">
                {{ scope.row.sourceOfComponents === 1 ? "收费件" : "" }}
                {{ scope.row.sourceOfComponents === 2 ? "海外免费件" : "" }}
                {{ scope.row.sourceOfComponents === 3 ? "工厂免费件" : "" }}
                {{ scope.row.sourceOfComponents === 4 ? "供应商免费件" : "" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="workingHours"
              label="单件工时"
              align="center"
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              prop="shippingFee"
              label="运费"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.shippingFee }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="tariff"
              label="关税"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.tariff }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="otherExpenses"
              label="其他费用"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.otherExpenses }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="travelPrice"
              label="差旅费"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.travelPrice }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="managementFeeRate"
              label="管理费费率"
              align="center"
              min-width="120px"
            >
              <template slot-scope="scope">
                {{ scope.row.managementFeeRate }}%
              </template>
            </el-table-column>
            <el-table-column
              prop="laborCost"
              label="工时费用"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.laborCost }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="materialCost"
              label="材料费用"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.materialCost }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="faultPartTotalPrice"
              label="总金额"
              align="center"
              min-width="100px"
            >
              <template slot-scope="scope">
                <div>
                  {{ claimant.currency === 0 ? "￥" : "" }}
                  {{ claimant.currency === 1 ? "$" : "" }}
                  {{ scope.row.faultPartTotalPrice }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 费用信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            费用信息
          </div>
        </div>
        <div class="form-container">
          <!-- 工时 -->
          <el-form-item label="工时总量(h)">
            <el-input-number
              disabled
              v-model="claimant.manHour"
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
              style="width: 300px"
              class="number-input"
            ></el-input-number>
          </el-form-item>
          <!-- 工时单价 -->
          <el-form-item label="工时单价">
            <el-input-number
              disabled
              v-model="claimant.hourlyRate"
              :controls="false"
              :precision="2"
              style="width: 300px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 工时总费用 -->
          <el-form-item label="工时总费用">
            <el-input-number
              disabled
              v-model="claimant.totalCostOfWork"
              :controls="false"
              :precision="2"
              style="width: 300px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料总费用 -->
          <el-form-item label="材料总费用" prop="materialTotalCost">
            <el-input-number
              disabled
              v-model="claimant.materialTotalCost"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 运费 -->
          <el-form-item label="运费总费用">
            <el-input-number
              disabled
              v-model="claimant.freight"
              :controls="false"
              :precision="2"
              style="width: 300px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 关税 -->
          <el-form-item label="关税总费用" prop="tariff">
            <el-input-number
              disabled
              v-model="claimant.tariff"
              :controls="false"
              :precision="2"
              style="width: 300px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>

          <!-- 其他费用 -->
          <el-form-item label="其他总费用" prop="otherTotalCost">
            <el-input-number
              v-model="claimant.otherTotalCost"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
              :disabled="true"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 差旅费 -->
          <el-form-item label="差旅费" prop="travelPrice">
            <el-input-number
              :disabled="true"
              v-model="claimant.travelPrice"
              :controls="false"
              :precision="2"
              style="width: 250px"
              class="number-input prepend-padding"
              placeholder="请输入"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <br />
          <!-- 其他费用说明 -->
          <el-form-item label="其他费用说明原文">
            <el-input disabled v-model="claimant.otherExpenses"></el-input>
          </el-form-item>
          <el-form-item label=" " label-width="60px">
            <translate
              :content="claimant.otherExpenses"
              field="otherExpensesCn"
              @getTranslateVal="getTranslateVal"
            />
          </el-form-item>
          <br />
          <el-form-item label="其他费用说明">
            <el-input disabled v-model="claimant.otherExpensesCn"></el-input>
          </el-form-item>
          <br />
          <!-- 索赔总费用 -->
          <el-form-item label="索赔总费用">
            <el-input-number
              disabled
              v-model="claimant.claimTotalCost"
              :controls="false"
              :precision="2"
              style="width: 300px"
              class="number-input prepend-padding"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ claimant.currency === 0 ? "￥" : "" }}
              {{ claimant.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 结算币种 -->
          <el-form-item label="结算币种">
            <el-select disabled v-model="claimant.currency" placeholder="" filterable clearable>
              <el-option label="CNY" :value="0"> </el-option>
              <el-option label="USD" :value="1"> </el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- 附件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            附件信息
          </div>
        </div>
        <div class="form-container">
          <el-form-item label="附件信息">
            <div
              class="flex"
              v-for="(item, i) in claimant.kdClaimFaultyPartsEntityList"
              :key="i"
            >
              <span style="font-weight: bold">附件{{ i + 1 }}:</span>
              <div class="file">
                <div
                  class="file-list"
                  style="cursor: pointer"
                  v-for="(data, idx) in item.fileList"
                  :key="idx"
                >
                  <div class="left">
                    <i class="el-icon-document"></i
                    ><span>{{ data.fileName }}</span>
                  </div>
                  <div class="down-icon" v-if="data.downStatus">已下载</div>
                  <div class="right" @click="downLoad(data.filePath, data)">
                    下载
                  </div>
                  <div
                    class="right"
                    style="margin-left: 10px"
                    v-if="showViewBtn(data.fileType)"
                    @click="viewFile(data)"
                  >
                    预览
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <!-- 审核信息 -->
        <last-audit
          v-if="
            claimant.claimStatementAudit &&
              (claimant.claimStatementAudit.auditType ||
                claimant.claimStatementAudit.auditType === 0)
          "
          :claimant="claimant"
        />
      </el-form>
    </div>
    <div v-else class="record_info">
      <!-- 车辆基本信息 -->
      <div class="hearder-title">
        <div class="flex_between">
          <img
            class="title-icon"
            src="@/assets/img/title-icon.svg"
            alt="dark"
          />
          历史记录
          <el-button
            style="margin-left: 20px"
            type="primary"
            size="mini"
            @click="handleViewRecord('detail')"
            >返回</el-button
          >
        </div>
      </div>
      <div class="form-container">
        <audit-record :recordList="recordList" />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      width="80%"
      title="历史记录"
      :visible.sync="historyDialog"
    >
      <historyList
        ref="historyRef"
        :vin="claimant.vin"
        :claimantNum="claimant.claimStatementNum"
      />
    </el-dialog>
    <view-img-video ref="viewRef" :list="previewList" />
  </div>
</template>
<script>
import { getSession } from "@/util/localStor";
import Translate from "@/components/translate";
import LastAudit from "./components/lastAudit.vue";
import AuditRecord from "./components/auditRecord.vue";
import { getDictItem, getDictValueByCodeText, getDictValue } from "@/util/dict";
import {
  messageReading,
  kdgetClimantDetail,
  gysPriceFillOutdataList
} from "@/api/seek";
import { auditHistoryList, kdAuditHistoryList } from "@/api/kdsuopei";
import ViewImgVideo from "@/components/viewImgVideo.vue";
import zipBtn from "@/components/downloadZip";
import historyList from "./components/historyList.vue";
export default {
  components: {
    Translate,
    LastAudit,
    AuditRecord,
    ViewImgVideo,
    zipBtn,
    historyList
  },
  data() {
    return {
      splxList: [
        {
          name: "运输损坏",
          id: "1"
        },
        {
          name: "货差",
          id: "2"
        },
        {
          name: "质量问题",
          id: "3"
        },
        {
          name: "状态不符",
          id: "4"
        },
        {
          name: "其他",
          id: "5"
        }
      ], //索赔类型
      partMajorList: [
        {
          name: "车身",
          id: "1"
        },
        {
          name: "底盘",
          id: "2"
        },
        {
          name: "电器",
          id: "3"
        },
        {
          name: "内外饰",
          id: "4"
        },
        {
          name: "新能源",
          id: "5"
        },
        {
          name: "动力",
          id: "6"
        }
      ], //零部件专业
      historyDialog: false,
      previewList: [],
      claimant: {},
      responsibilityTypeList: [],
      supplierList: [],
      responsibilityDepartmentListObj: {
        responsibilityPart1: [],
        responsibilityPart2: [],
        responsibilityPart3: []
      }, // 责任部门列表对象
      isLoading: false,
      formLoading: false,
      claimant: {},
      pageIndex: "detail",
      recordList: [],
      exchangeRate: "1",
      fileList: []
    };
  },
  async created() {
    this.responsibilityTypeList = await getDictItem("responsibilityType");
    if (
      this.claimant.responsibilityPartList &&
      this.claimant.responsibilityPartList.length > 0
    ) {
      this.claimant.responsibilityPartList.map((item, index) => {
        this.getSupplierList(item, index);
      });
    }
  },
  async mounted() {
    // this.getExchangeRate();
    // 将未读消息改为已读
    if (
      this.$route.query?.messageId &&
      !(this.$route.query?.messageStatus == 1)
    ) {
      messageReading({
        data: { messageList: [this.$route.query?.messageId] }
      });
    }
    if (this.$route.query?.claimantId) {
      this.isLoading = true;
      this.formLoading = false;
      const res = await kdgetClimantDetail(this.$route.query?.claimantId);
      if (res.status == 0) {
        this.claimant = res.data || {};
      } else {
        this.$DonMessage.error(res.message);
      }
      this.isLoading = false;
      this.formLoading = true;
    }
    this.fileList = this.claimant.kdClaimFaultyPartsEntityList?.reduce(
      (acc, item) => {
        if (item.fileList && item.fileList.length > 0) {
          acc.push(...item.fileList);
        }
        return acc;
      },
      []
    ); // 初始值为空数组
    this.previewList = this.fileList?.filter(item => {
      return "image,video".indexOf(item.fileType.slice(0, 5)) !== -1;
    });
    const res2 = await auditHistoryList({
      data: { claimStatementId: this.claimant.claimStatementId }
    });
    this.recordList = res2.data;
  },
  methods: {
    getSession,
    getDictValueByCodeText,
    // 获取责任部门列表
    async getResponsibilityDepartmentList(field) {
      const responsibilityDepartmentList = await getDictItem(field);
      this.responsibilityDepartmentListObj[
        field
      ] = responsibilityDepartmentList;
    },
    // 责任类型改变
    responsibilityTypeChange(row, index) {
      this.claimant.responsibilityPartList[index].faultPartNumber = ""; // 情况故障件
      if (row.responsibilityType == "1") {
        this.claimant.responsibilityPartList[index].responsibilityDepartment =
          "";
      } else if (row.responsibilityType == "2") {
        this.claimant.responsibilityPartList[index].responsibilityDepartment =
          "供应商";
      } else {
        this.claimant.responsibilityPartList[index].responsibilityDepartment =
          "海外事业部";
      }
    },
    // 责任部门改变
    responsibilityDepartmentChange(row, index) {
      this.claimant.responsibilityPartList[index].responsibilitySupplier = "";
    },
    // 获取供应商列表
    getSupplierList(row, index) {
      if (!row.faultPartNumber) return;
      gysPriceFillOutdataList({ faultPartNumber: row.faultPartNumber }).then(
        res => {
          if (res.status == 0) {
            this.$set(this.supplierList, index, res.data || []);
          }
        }
      );
    },
    // 责任故障件件号改变
    responsibilityPartNumberChange(row, index) {
      [
        ...this.claimant.faultPartsList,
        {
          faultPartNumber: this.claimant.faultPartNumber,
          faultPartName: this.claimant.faultPartNameZh
        }
      ].map(item => {
        if (item.faultPartNumber == row.faultPartNumber) {
          this.claimant.responsibilityPartList[index].faultPartName =
            item.faultPartName;
        }
      });
      this.getSupplierList(row, index);
    },

    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    // 打开历史详情记录
    handleHistory() {
      this.historyDialog = true;
      this.$nextTick(() => {
        this.$refs.historyRef.initData();
      });
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 获取翻译值
    getTranslateVal(field, value) {
      this.$set(this.claimant, field, value);
    },
    // 详情 | 记录
    handleViewRecord(index) {
      this.pageIndex = index;
    },
    // 下载
    downLoad(url, data) {
      this.$set(data, "downStatus", true);
      window.open(url);
    },
    showViewBtn(type) {
      const fileExtension = type.slice(0, 5);
      return "image,video".indexOf(fileExtension) !== -1;
    },
    // 预览
    viewFile(data) {
      this.$refs.viewRef.init(data);
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.seek_detail_page {
  padding-bottom: 20px;
  .top-container {
    position: sticky;
    top: 0;
    z-index: 999;
    background-color: #fff;
    padding: 15px 32px 15px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .status-container {
    display: flex;
    align-items: baseline;
    padding: 13px 44px;
    border-bottom: 1px solid #dcdee0;
    .status {
      margin: 0 85px;
    }
    .btn {
      color: #4084ff;
      padding: 0;
      font-size: 16px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .form-container {
    margin-top: 34px;
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .fanyi-box {
    padding-left: 50px;
    ::v-deep .el-textarea__inner {
      height: 100px;
    }
    .textAreaTipBtn {
      cursor: pointer;
      width: fit-content;
      color: #1890ff;
    }
  }
}
.file {
  .down-icon {
    margin-left: 10px;
    color: #1890ff;
  }
  .file-list {
    margin: 0 10px;
    padding: 0 5px;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: flex;
    i {
      font-size: 20px;
    }
    span {
      display: inline-block;
      font-size: 12px;
      margin-left: 5px;
    }
    .right {
      font-size: 12px;
      padding: 0 5px;
      border: 1px solid #4095e5;
      text-align: center;
      margin-left: 30px;
      border-radius: 6px;
      height: 26px;
      line-height: 26px;
      box-sizing: border-box;
      opacity: 0;
    }
  }
  .file-list:hover {
    background: rgb(243, 246, 249);
    color: #4095e5;
    .right {
      opacity: 1;
    }
  }
}
</style>
